'use client'

import * as UI from '../footer.styled'
import {MailQuestion, Phone} from 'lucide-react'
import React from 'react'

import {Link} from '@/src/shared/ui/link'
import {onlyDigits} from '@/src/shared/utils/functions'
import {getInjection} from '@runlab/di'

interface FooterContactsProps {
  readonly phone: string
  readonly onCallRequest: () => void
  readonly onFeedback: () => void
}

export const FooterContacts: React.FC<FooterContactsProps> = ({phone, onCallRequest, onFeedback}) => {
  const phoneLink = `tel:${onlyDigits(phone)}`

  const onClickTel = (phone: string) => {
    getInjection('PulseAnalytics').track('phone_click', { phone })
  }

  return (
    <>
      <UI.ContactPhone href={phoneLink} onClick={() => onClickTel(phone)}>{phone}</UI.ContactPhone>
      <UI.Link
        iconAfter={<Phone />}
        as={Link}
        onClick={e => {
          e.preventDefault()
          onCallRequest()
        }}>
        Заказать звонок
      </UI.Link>
      <UI.Link
        iconAfter={<MailQuestion />}
        as={Link}
        onClick={e => {
          e.preventDefault()
          onFeedback()
        }}>
        Задать вопрос
      </UI.Link>
    </>
  )
}
